/*
 * The english translation of all files relating to the AdminView
 */
export const ADMIN_VIEW_EN = {
  // UserTableDropDown.vue
  updateUser: 'Update User',
  resetUserPassword: 'Reset Password',
  // useAdminNavigation.ts
  createOrganisation: 'CREATE ORGANISATION',
  // OrgaAdminUserUpdate.vue
  updateUserDescription: "Update a user. Click save when you're done.",
  typeTheFullName: 'Type the full name.',
  notEditable: 'not editable',
  usersEmailAddress: "User's email address",
  promptName: 'Prompt Name',
  // Affiliate Management
  affiliates: 'Affiliates',
  createAffiliate: 'Create Affiliate',
  affiliateCode: 'Affiliate Code',
  partnerName: 'Partner Name',
  partnerEmail: 'Partner Email',
  trialExtensionDays: 'Trial Extension Days',
  signUps: 'Sign-ups',
  conversions: 'Conversions',
  mrr: 'MRR',
  deactivate: 'Deactivate',
  noAffiliatesFound: 'No affiliates found',
  affiliateCreated: 'Affiliate code created',
  adminActiveHeartbeatTitle: 'Active Agents',
  adminActiveHeartbeatDescription:
    'Overview of all enabled agents across global, organisation, and user scopes.',
  adminActiveHeartbeatEmpty: 'No active agents found.',
  adminActiveHeartbeatEmptyFiltered: 'No active agents match the selected scope.',
  adminActiveHeartbeatLoadFailed: 'Failed to load active agents.',
  adminHeartbeatScopeGlobal: 'Global',
  adminHeartbeatScopeOrg: 'Organisation',
  adminHeartbeatScopeUser: 'User',
  adminHeartbeatScopeUnknown: 'Unknown',
  adminHeartbeatScopeFallback: 'No scope target'
}
/*
 * The german translation of all files relating to the AdminView
 */
export const ADMIN_VIEW_DE = {
  // UserTableDropDown.vue
  updateUser: 'Benutzer aktualisieren',
  resetUserPassword: 'Passwort zurücksetzen',
  // useAdminNavigation.ts
  createOrganisation: 'ORGANISATION ERSTELLEN',
  // OrgaAdminUserUpdate.vue
  updateUserDescription:
    'Aktualiseren Sie einen Benutzer. Klicken Sie speichern, wenn Sie fertig sind.',
  typeTheFullName: 'Tippen Sie den vollen Namen ein.',
  notEditable: 'nicht bearbeitbar',
  usersEmailAddress: 'E-Mail-Adresse des Benutzers',
  promptName: 'Prompt Name',
  // Affiliate Management
  affiliates: 'Affiliates',
  createAffiliate: 'Affiliate erstellen',
  affiliateCode: 'Affiliate-Code',
  partnerName: 'Partnername',
  partnerEmail: 'Partner-E-Mail',
  trialExtensionDays: 'Testverlängerung (Tage)',
  signUps: 'Anmeldungen',
  conversions: 'Konvertierungen',
  mrr: 'MRR',
  deactivate: 'Deaktivieren',
  noAffiliatesFound: 'Keine Affiliates gefunden',
  affiliateCreated: 'Affiliate-Code erstellt',
  adminActiveHeartbeatTitle: 'Aktive Agenten',
  adminActiveHeartbeatDescription:
    'Überblick über alle aktivierten Agenten über globale, Organisations- und Nutzer-Scopes hinweg.',
  adminActiveHeartbeatEmpty: 'Keine aktiven Agenten gefunden.',
  adminActiveHeartbeatEmptyFiltered: 'Keine aktiven Agenten für den gewählten Scope gefunden.',
  adminActiveHeartbeatLoadFailed: 'Aktive Agenten konnten nicht geladen werden.',
  adminHeartbeatScopeGlobal: 'Global',
  adminHeartbeatScopeOrg: 'Organisation',
  adminHeartbeatScopeUser: 'Nutzer',
  adminHeartbeatScopeUnknown: 'Unbekannt',
  adminHeartbeatScopeFallback: 'Kein Scope-Ziel'
}
